import styled from "@emotion/styled";
import { Box } from "@material-ui/core";

export const FileItem = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 25px;
    height: 25px;
    margin-right: 12px;
  }
  h4 {
    font-size: 1.1rem;
  }
`;

export const FileList = styled.div`
  margin-top: 1rem;
  max-height: 210px;
  overflow-y: scroll;
  overflow-x: visible;
`;

export const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  > span {
    width: calc(100% - 42px);
  }
`;
